import { render, staticRenderFns } from "./TextStyle.vue?vue&type=template&id=6ac59aa0&scoped=true&"
import script from "./TextStyle.vue?vue&type=script&lang=js&"
export * from "./TextStyle.vue?vue&type=script&lang=js&"
import style0 from "./TextStyle.vue?vue&type=style&index=0&id=6ac59aa0&lang=scss&scoped=true&"
import style1 from "./TextStyle.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac59aa0",
  null
  
)

export default component.exports